import React, { useEffect } from "react";
import { connect } from "react-redux";
import "./index.css";
import "../index.css";

const IndicatorTimeline = (props) => {
  const {
    index,
    activePoint,
    setActivePoint,
    rotateClass,
    customLeft,
    onePoint,
  } = props;
  useEffect(() => {
    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {activePoint === index ? (
        <div
          className={`indicator_timeline${rotateClass ? " rotate" : ""}`}
          style={{
            left: customLeft ? customLeft : "",
          }}
        >
          <span className="indicator_oval_white">
            <span className="indicator_oval_red" />
          </span>
          {onePoint === undefined && (
            <>
              <span
                className={`line_black ${rotateClass ? "small_line_black" : ""}`}
              ></span>
              <span className="final_oval_black"></span>
            </>
          )}
        </div>
      ) : (
        <div
          className={`indicator_timeline${rotateClass ? " rotate" : ""}`}
          onClick={() => {
            setActivePoint(index);
          }}
          style={{
            left: customLeft ? customLeft : "",
          }}
        >
          <span className="initialoval_black"></span>
          {onePoint === undefined && (
            <>
              <span
                className={`line_black ${rotateClass ? " small_line_black" : ""
                  }`}
              ></span>
              <span className="final_oval_black"></span>
            </>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  settings: state.settings,
});

export default connect(mapStateToProps)(IndicatorTimeline);
